import { forwardRef, type TextareaHTMLAttributes } from "react";

import { fieldClasses } from "./Input";
import { cn } from "./lib/cn";

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, rows = 4, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cn("min-h-24 px-3.5 py-2.5", fieldClasses, className)}
      {...rest}
    />
  );
});
